module.exports = __webpack_public_path__ + "static/img/2-4.0dd4333c.png";